@defer (when initialContentData()) {
  <div class="input-container">
    @if (hasTemplateNameField()) {
      <glxy-form-field [required]="true">
        <glxy-label>{{ 'CONTENT_BUILDER.TEMPLATE_NAME' | translate }}</glxy-label>
        <input matInput [formControl]="templateNameControl" data-testid="email-ui-builder-v3-builder-template-name" />
        @if (templateNameControl.hasError('required') && templateNameControl.touched) {
          <glxy-error>{{ 'CONTENT_BUILDER.NAME_REQUIRED' | translate }}</glxy-error>
        }
        @if (templateNameControl.hasError('base64Image') && templateNameControl.touched) {
          <glxy-error>{{ 'CONTENT_BUILDER.VALIDATION_ERRORS.BASE64_IMAGE' | translate }}</glxy-error>
        }
      </glxy-form-field>
    }

    @if (hasSubjectLineField()) {
      <email-input-with-dynamic-contents
        data-testid="email-ui-builder-v3-builder-subject"
        [title]="'CONTENT_BUILDER.SUBJECT_LINE' | translate"
        [required]="true"
        [elementId]="subjectLineElementId"
        [content]="subjectLineControl.value || ''"
        [validators]="base64Validators"
        (contentChange)="onSubjectLineChange($event)"
        (contentValid)="updateValidity('subjectLine', $event)"
      />
    }

    @if (hasPreviewTextField()) {
      <email-input-with-dynamic-contents
        data-testid="email-ui-builder-v3-builder-preview-text"
        [title]="'CONTENT_BUILDER.INBOX_PREVIEW_TEXT' | translate"
        [titleHint]="'CONTENT_BUILDER.INBOX_PREVIEW_TEXT_HINT' | translate"
        [required]="false"
        [elementId]="inboxPreviewElementId"
        [content]="inboxPreviewControl.value || ''"
        [validators]="base64Validators"
        (contentChange)="onInboxPreviewChange($event)"
        (contentValid)="updateValidity('previewText', $event)"
      />
    }

    @if (hasSupportedBlocks()) {
      <mat-divider />

      <email-block-list
        [initialContentBlocks]="initialContentData().contentBlocks || []"
        (contentBlocksChange)="onContentBlocksChange($event)"
      />
    }
  </div>

  @if (hasAnySettings()) {
    <mat-accordion [multi]="true">
      @if (hasColorsSetting()) {
        <mat-expansion-panel data-testid="email-ui-builder-v3-builder-colors-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'CONTENT_BUILDER.COLORS' | translate }}
              @if (validityMap()['colorSettings'] === false) {
                <mat-icon class="error-icon">error</mat-icon>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <email-colors-settings
            [settings]="initialContentData().contentSetup?.colors"
            (settingsChange)="onColorSettingsChange($event)"
            (settingsValid)="updateValidity('colorSettings', $event)"
          />
        </mat-expansion-panel>
      }

      @if (hasSizingSetting()) {
        <mat-expansion-panel data-testid="email-ui-builder-v3-builder-sizing-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'CONTENT_BUILDER.SIZING_AND_SPACING' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <email-sizing-and-spacing-settings
            [settings]="initialContentData().contentSetup?.pageSetup"
            (settingsChange)="onPageSetupChange($event)"
          />
        </mat-expansion-panel>
      }

      @if (hasTopLogoSetting()) {
        <mat-expansion-panel data-testid="email-ui-builder-v3-builder-logo-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'CONTENT_BUILDER.TOP_LOGO' | translate }}
              @if (validityMap()['topLogo'] === false) {
                <mat-icon class="error-icon">error</mat-icon>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <email-top-logo-settings
            [settings]="initialContentData().contentSetup?.topLogo"
            (settingsChange)="onTopLogoSettingsChange($event)"
            (settingsValid)="updateValidity('topLogo', $event)"
          />
        </mat-expansion-panel>
      }

      @if (hasFooterSetting()) {
        <mat-expansion-panel data-testid="email-ui-builder-v3-builder-footer-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'CONTENT_BUILDER.FOOTER' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <email-footer-settings
            [settings]="initialContentData().contentSetup?.footer"
            (settingsChange)="onFooterSettingsChange($event)"
          />
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
} @loading {
  <glxy-loading-spinner></glxy-loading-spinner>
}
